import { RingProgress, Text, Center, Stack } from '@mantine/core'

function getScoreColor(score: number): string {
  if (score >= 80) return 'teal'
  if (score >= 60) return 'yellow'
  if (score >= 40) return 'orange'
  return 'red'
}

interface ScoreGaugeProps {
  score: number
  size?: number
  thickness?: number
  label?: string
}

export function ScoreGauge({ score, size = 140, thickness = 12, label }: ScoreGaugeProps) {
  const color = getScoreColor(score)
  return (
    <Stack align="center" gap={4}>
      <RingProgress
        size={size}
        thickness={thickness}
        roundCaps
        sections={[{ value: score, color }]}
        label={
          <Center>
            <Text fw={700} size="xl" ta="center">
              {score}
            </Text>
          </Center>
        }
      />
      {label && (
        <Text size="xs" c="dimmed" ta="center">
          {label}
        </Text>
      )}
    </Stack>
  )
}
